import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Fade from "react-bootstrap/Fade";

import BadgeComponent from "./Badge";
import Chevron from "../Icons/Chevron";
import Link from "./Link";

const propTypes = {
  badge: PropTypes.number,
  header: PropTypes.string.isRequired,
  defaultShow: PropTypes.bool
};

const defaultShow = {
  defaultShow: false
};

const Reveal = ({ children, badge, header, defaultShow, ...props }) => {
  /**
   * state
   */
  const [toggle, setToggle] = useState(defaultShow);

  return (
    <Wrapper {...props}>
      <Link
        onClick={() => setToggle(!toggle)}
        className="gap-6 d-flex justify-content-between align-items-center text-decoration-none p-6 text-black"
      >
        <p className="fw-bold reveal__header">{header}</p>

        <div className="d-flex gap-8">
          {Boolean(badge) && <Badge>{badge}</Badge>}
          <Chevron direction={toggle ? "up" : "down"} />
        </div>
      </Link>

      <Fade in={toggle} mountOnEnter unmountOnExit>
        <div className="px-6 pb-6 reveal__body">{children}</div>
      </Fade>
    </Wrapper>
  );
};

/**
 * styles
 */
const Badge = styled(BadgeComponent)`
  display: flex;
  padding-top: 0;
  padding-bottom: 0;
  align-items: center;
  border-radius: 2.75rem;
`;

const Wrapper = styled.div`
  border-radius: 2px;
  border: solid 1px var(--bs-gray-20);
`;

Reveal.propTypes = propTypes;
Reveal.defaultShow = defaultShow;

export default Reveal;
